import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, createVNode as _createVNode, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, Transition as _Transition, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "wrapper" }
const _hoisted_2 = {
  key: 0,
  class: "content-section"
}

import Icon from "@/components/shared/Icon.vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'CollapsibleSection',
  props: {
    isVisible: { type: Boolean, default: false },
    inverted: { type: Boolean, default: false },
    useDefaultToggle: { type: Boolean, default: false }
  },
  setup(__props: any) {

const props = __props;

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (!!_ctx.$slots.toggle || __props.useDefaultToggle)
      ? _renderSlot(_ctx.$slots, "toggle", { key: 0 }, () => [
          _createVNode(Icon, {
            class: "toggle",
            icon: __props.isVisible ? 'chevron-up' : 'chevron-down',
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('toggle')))
          }, null, 8, ["icon"])
        ])
      : _createCommentVNode("", true),
    _createVNode(_Transition, {
      name: __props.inverted ? 'slide-up' : 'slide-down'
    }, {
      default: _withCtx(() => [
        (__props.isVisible)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
              _renderSlot(_ctx.$slots, "default", {}, () => [
                _cache[1] || (_cache[1] = _createTextVNode("Default content to slide...", -1))
              ])
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 3
    }, 8, ["name"])
  ]))
}
}

})